// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"7853cd05","777":"00c55331"}[chunkId] + ".chunk.css";
};